import {View, Text} from '@react-pdf/renderer';

import {applicantMatchText} from '../../../../../../../lib/constants';
import {cultureTypeOverviewStyles as styles} from '../../styles/culture-type-overview';
import {sharedStyles} from '../../styles/shared-styles';

interface Props {
  matchPercentage?: string;
  currentLanguage: 'en' | 'de';
  hideText?: boolean;
}

export const PdfMatchBar = ({matchPercentage, currentLanguage, hideText}: Props) => {
  const getText = (percent: number) => {
    if (percent < 70) {
      return applicantMatchText.low[currentLanguage];
    }
    if (percent < 85) {
      return applicantMatchText.mid[currentLanguage];
    }

    return applicantMatchText.high[currentLanguage];
  };

  const validMatchPercentage = matchPercentage ? parseFloat(matchPercentage.replace('%', '')) : 0;

  return (
    <View>
      {!hideText && <Text style={styles.matchText}>{getText(validMatchPercentage)}</Text>}
      <View style={styles.matchBarWrapper}>
        <View style={{...styles.matchBar, width: `${validMatchPercentage}%`}}>
          <Text style={{...sharedStyles.text, marginBottom: 0, textAlign: 'right'}}>{matchPercentage}</Text>
        </View>
      </View>
    </View>
  );
};
